import React from "react";
import './TodoNotFound.css';

function TodoNotFound() {
    return(
        <p className="TodoNotFound">No matches found</p>
    )
}

export { TodoNotFound };